import { faCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Checkbox, Radio } from "@material-ui/core";
import { AddCircle, ImportContactsRounded, ReportProblemRounded } from "@material-ui/icons";
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { Steper } from "./SmallComps/Steper";
import bgMain from "./../../assets/Campaign/bgCampaign.png"
import bgBlur from "./../../assets/Campaign/bgCampaignLogin.png"
import { TextInputWTitle } from "./SmallComps/TextInputWTitle";
import { InputTitle } from "./SmallComps/InputTitle";
import { checkIsMobile } from "../Functions/CheckUserData";
import { PostDataPromise } from "../Functions/SendingData";
import { makeNumEn } from "../Functions/Numerals";
import { Loading } from "../Loading";
import useInterval from "../Functions/useInterval";
import { logintext } from "../../Lang/fa/Login";
import { isLoginOut } from "../../App";
import RibbonSuggetGood from "./RibbonSuggetGood"
import { ColorsCampaign } from "../../assets/Campaign/ColorsCampaign";
import { insertGood } from "../Menu/UniBasket";
import GoodCartWithSelector from "./SmallComps/GoodCartWithSelector";
import GoodCartWithSelectorDouble from "./SmallComps/GoodCartWithSelectorDouble";
import RibbonSuggetGoodSelector from "./RibbonSuggetGoodSelector";


const Styles =styled.div`
    --n-primary-2: #0E3D5C;
    --n-grey-2: #E5E5E5;
    --n-grey-3: #CBCBCB;
    --n-grey-7: #979797;
    --n-grey-9: #5E5E5E;

    margin: 1rem 0 4rem;
    .title-box {
        width: 100%;
        grid-column: 2/14;
        text-align: right;
        margin-bottom: 2rem;
        .text-box {
            font-size: 1.5rem;
            font-weight: 700;
        }
        .desc-box {
            margin-top: 0.9rem;
            font-size: 0.9rem;
            font-weight: 700;
            color: var(--n-grey-7);
        }
    }
    .box {
        width: calc(100%);
        grid-column: 2/14;
        padding: 1rem 0;
        background-color: #fff;
        border-radius: 8px;
        /* box-shadow: 0 4px 10px -5px #000; */
        box-shadow: 0px 4px 30px -4px #0000001F;
        display: flex;
        flex-direction: column;
        gap: 0.5rem;   
        &.top {
            min-height: 5rem;
            margin: 0 0 0.5rem
        } 
        &.answers {
            width: calc(100% - 2rem);
            margin-bottom: 1rem;
            padding: 1rem;
            text-align: justify;
        }
    }
    .box-2 {
        width: calc(100%);
        grid-column: 2/14;
        margin: 0 0 1rem;
        position: relative;
        &.text-title {
            text-align: right;
            margin-top: 2rem;
            margin-bottom: 1rem;
            font-size: 0.9rem;
            font-weight: 700;
        }
    }
    .ans {
        width: calc(100%);
        grid-column: 2/14;
        padding: 0 0 1rem;
        min-height: 60vh;
        position: relative;
        .background {
            position: absolute;
            inset: 0;
            filter: blur(10px);
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
        .login {
            width: 50%;
            position: absolute;
            height: 50vh;
            top: calc(50% - 25vh);
            right: 25%;
            background-color: #fff;
            box-shadow: 0px 4px 30px -4px #0000001F;
            border: 1px solid var(--n-grey-2);
            border-radius: 4px;
            display: flex;
            flex-direction: column;
            .top {
                border-bottom: 1px solid var(--n-grey-2);
                display: flex;
                padding: 1rem 1rem 1rem;
                font-size: 1.2rem;
                font-weight: 500;
            }
            .content {
                flex-grow: 1;
                text-align: right;
                padding: 0.5rem 1rem 0.5rem;
                font-size: 0.9rem;
                display: flex;
                flex-direction: column;
                gap: 0.5rem;
            }
            .actions {
                border-top: 1px solid var(--n-grey-2);
                padding: 1rem 16px 1rem;
                gap: 1rem;
                .btn-1 {
                    min-width: 150px;
                }
                .btn-2 {
                    flex-grow: 1;
                }
            }
        }
    }
    .title {
        margin: 1rem 0 0;
        text-align: right;
        font-size: 1.3rem;
        font-weight: 600;
    }
    .q-divider {
        width: calc(100% - 32px);
        margin: 0 16px;
        height: 1px;
        background-color: var(--n-grey-2);
    }
    .q-simple {
        text-align: right;
        padding: 1rem 0;
        .text-q {
            padding: 0 16px;
            font-size: 1.2rem;
            margin-bottom: 1.5rem;
            font-weight: 500;
            display: flex;
            .circle {
                position: relative;
                top: 0.2rem;
                color: var(--n-grey-3);
                margin-left: 0.5rem;
                &.error {
                    color: var(--secondry-1);
                }
                &.active {
                    color: var(--o-prime-2);
                }
            }
        }
        .data-q {
            padding: 0 7px;
            display: flex;
            gap: 4rem;
            row-gap: 1rem;
            flex-wrap: wrap;
            font-size: 1rem;
            font-weight: 400;
            label {
                cursor: pointer;
            }
        }
        .desc-q {
            padding: 0 16px;
            margin: 0.5rem 0 0;
            font-size: 0.8rem;
            font-weight: 700;
            color: var(--n-grey-7);
        }
        .data-q-image {
            padding: 0 16px;
            display: flex;
            gap: 0.5rem;
            row-gap: 1rem;
            flex-wrap: wrap;
            font-size: 1rem;
            font-weight: 400;
            label {
                cursor: pointer;
            }
            .item-range {
                cursor: pointer;
                display: flex;
                flex-direction: column;
                padding: 4px 2px 3px;
                border-radius: 4px;
                border: 1px solid var(--n-grey-2);
                gap: 4px;
                min-width: 24px;
                text-align: center;
                font-weight: 600;
                &.active {
                    border: 1px solid var(--n-primary-2);
                    background-color: var(--n-primary-2);
                    color: #fff;
                    box-shadow: 0px 0px 0px 4px #0E3D5C29;
                }
            }
            .item-image {
                cursor: pointer;
                display: flex;
                flex-direction: column;
                padding: 4px;
                border-radius: 4px;
                border: 1px solid var(--n-grey-2);
                gap: 4px;
                &.active {
                    border: 1px solid var(--n-primary-2);
                    box-shadow: 0px 0px 0px 4px #0E3D5C29;
                }
                img {
                    width: 60px;
                    height: 100px;
                    object-fit: cover;
                    display: block;
                    border-radius: 4px;
                }
                .item-image-text {
                    font-size: 0.7rem;
                    color: var(--n-grey-9);
                }
                .item-image-desc {
                    font-size: 0.5rem;
                    color: var(--n-grey-7);
                }
            }
        }
    }
    .colors-ans {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 0.5rem;
        margin-bottom: 0.5rem;
        .item-image {
            cursor: pointer;
            display: flex;
            flex-direction: column;
            padding: 4px;
            border-radius: 4px;
            border: 1px solid var(--n-grey-2);
            gap: 8px;
            &.active {
                border: 1px solid var(--n-primary-2);
                box-shadow: 0px 0px 0px 4px #0E3D5C29;
            }
            .item-image-data {
                display: flex;
                flex-direction: column;
                gap: 1rem;
            }
            img {
                width: 120px;
                height: 150px;
                object-fit: cover;
                display: block;
                border-radius: 4px;
            }
            .item-image-text {
                font-size: 1.3rem;
                color: var(--n-grey-9);
            }
            .item-image-desc {
                font-size: 1rem;
                color: var(--n-grey-7);
            }
        }
    }
    .actions {
        display: flex;
        justify-content: space-between;
        text-align: right;
        padding: 1rem 16px 1rem;
        &.end {
            padding: 1rem 16px 1rem;
        }
        .btn {
            min-width: 200px;
        }
        &.error {
            padding: 1rem 16px 0.5rem;
            justify-content: start;
            color: var(--secondry-1);
            gap: 0.5rem;
        }
    }
    @media screen and (max-width: 850px) {
        .title-box {
            grid-column: 2/6;
        }
        .box {
            width: calc(100%);
            grid-column: 1/7;
            border-radius: 0;
        }
        .box-2 {
            width: calc(100%);
            grid-column: 1/7;
            border-radius: 0;
        }
        .q-divider {
            width: calc(100%);
            margin: 0 0;
            height: 1px;
            background-color: var(--n-grey-2);
        }
        .actions {
            display: flex;
            justify-content: space-between;
            text-align: right;
            /* border-top: 1px solid var(--n-grey-2); */
            padding: 2rem 16px 1rem;
            .btn {
                min-width: 40vw;
            }
        }
        .ans {
            grid-column: 1/7;
            .login {
                width: 100%;
                min-height: 18rem;
                height: 35vh;
                top: 0;
                right: 0;
            }
        }
    }
`

const SurveyComp =()=>{
    const mainRef = useRef();
    const mainselector = useRef();
    const [step, setStep] = useState("step1");
    const [mobile, setMobile] = useState("");
    const [pass, setPass] = useState("");
    const [errMobile, setErrMobile] = useState("");
    const [loadingLogin, setLoadingLogin] = useState(false);
    const [loadingProds, setLoadingProds] = useState(false);
    const [loadedProds, setLoadedProds] = useState(false);
    const [loadedProdsData, setLoadedProdsData] = useState(false);
    const [colorsSelector, setColorsSelector] = useState([])
    const [colorsSelected, setColorsSelected] = useState(false);
    
    const [basketSelectedGoods, setBasketSelectedGoods] = useState([474,1371,1372])
    
    const [logicAns, setLogicAns] = useState({
        goods: [],
        colors: [],
        color: "شماره رنگ ",
        maxes: []
    });
    const [disNext, setDisNext] = useState(false);
    const [disBack, setDisBack] = useState(true);
    const [showError, setShowError] = useState(false);
    const [globalState, setGlobalState] = useState({});

    const [timer , setTimer] = useState('')
    const [time , setTime] = useState(120)
    const [puased , setPuased] = useState(true)

    useEffect(() => {
        getMainData()
    }, []);

    const getMainData = async() => {
        let formData = new FormData();
        formData.append('api_token', localStorage.getItem('token'));
        if(localStorage.getItem('token')){
            let userdata = JSON.parse(localStorage.getItem('userdata'));
            formData.append('U_CODE', userdata.usercode);
            formData.append('SURV_VERSION', "haircolor1");
            let response = await PostDataPromise(process.env.REACT_APP_API + '/api/v1/userprofile/survay/select',formData);
            let res = JSON.parse(response);
            if(res.status === "error"){
                setLoadedProds(false);
                return;
            } else {
                setLoadedProdsData(res.data);
                let states = JSON.parse(res.data.SURV_RESULT);
                setGlobalState(states);
                setColorsSelected(states["color18"])
                let logic = await makeLogic(states);
                setLogicAns(logic);
                setStep("step8");
                setLoadedProds(true);
            }
            // if(step === "step7"){
            //     let res = await makeLogic();
            //     setLogicAns(res);
            // }
        }
    }
    const sendData = async () => {
        let formData = new FormData();
        formData.append('api_token', localStorage.getItem('token'));
        if(localStorage.getItem('token')){
            let userdata = JSON.parse(localStorage.getItem('userdata'));
            formData.append('U_CODE', userdata.usercode);
            formData.append('SURV_VERSION', "haircolor1");
            formData.append('SURV_RESULT', JSON.stringify(globalState));
            let response;
            if(loadedProds){
                formData.append('SURV_CODE', loadedProdsData.SURV_CODE);
                response = await PostDataPromise(process.env.REACT_APP_API + '/api/v1/userprofile/survay/update',formData);
            }else {
                response = await PostDataPromise(process.env.REACT_APP_API + '/api/v1/userprofile/survay/insert',formData);
            }
            let res = JSON.parse(response);
            if(res.status === "error"){
                return;
            }
            // if(step === "step7"){
            //     let res = await makeLogic();
            //     setLogicAns(res);
            // }
        }
    }



    
    const interval = useInterval(
        ()=>{
            if(time > 0){
                setTime( time - 1)
                setTimer( <div className="subtext">ارسال مجدد کد تا {time} ثانیه دیگر</div>)
            }else{
                setPuased(true)
                setTime(0)
                window.clearInterval(interval.current)
                setTimer(<div className="subtext" onClick={sendLogin}> {logintext.resend}</div>)
            }
        }
        ,
        puased ? null  : 1000
    )


    const onchanged = (e) => {
        let find = questions.find((v) => v.enID === e.target.name);
        if(find){
            let temp = {...globalState};
            if(find.type === "simple"){
                temp[find.enID] = e.target.value;
            }
            if(find.type === "simpleimage"){
                temp[find.enID] = e.target.value;
            }
            if(find.type === "simplerange"){
                temp[find.enID] = e.target.value;
            }
            if(find.type === "multi"){
                let temp2 = []
                if(temp[find.enID]){
                    temp2 = temp[find.enID]
                }
                let temp3 = temp2;
                if(!temp3.length){
                    temp3 = []
                }
                let finding = temp3.findIndex((v) => parseInt(v) === parseInt(e.target.value));
                if(finding !== -1){
                    temp3.splice(finding, 1);
                } else if(temp3.length < find.max) {
                    temp3.push(e.target.value)
                }
                
                temp[find.enID] = temp3;
            }
            setGlobalState(temp);
        }
    }
    // console.log(globalState)
    const makeQuestions = () => {
        let newQuestiosn = [...questions];
        let showedQuestions = newQuestiosn.splice(stages[step].items[0], stages[step].items[1] - stages[step].items[0])
        return showedQuestions.map((v, i) => {
            let show = true
            if(v.showing){
                show = false;
                let find = questions.find((v2) => v2.enID === v.showing);
                let okays = v.paramShow.split("").map((v) => parseInt(v))
                if(okays.findIndex(value1 => parseInt(globalState[find.enID]) === value1) !== -1){
                    show = true;
                }
            }
            if(show === false){
                return "";
            }
            switch(v.type){
                case "title":
                    return (
                        <div className="title" key={i}>
                            {v.text}
                        </div>
                    )
                case "simple":
                    return (
                        <>
                        <div className="q-simple" key={i}>
                            <div className="text-q">
                                <FontAwesomeIcon className={"circle " + ((showError ? ((!globalState[v.enID]) ? "error": "active") : ((globalState[v.enID])? "active" : "")))} icon={faCircle}/>{v.title}
                            </div>
                            <div className="data-q">
                                {v.answers.map((vi, ii) => {
                                    return (
                                        <div key={ii}>
                                            {/* <input type="radio" id={vi} name={v.enID} value={ii+1} checked={((globalState[v.enID]) ?  ((parseInt(globalState[v.enID]) === ii+1) ? true : false)   : false)} onChange={onchanged}/> */}
                                            <Radio 
                                                type="radio" 
                                                name={v.enID} 
                                                value={ii+1} 
                                                checked={((globalState[v.enID]) ?  ((parseInt(globalState[v.enID]) === ii+1) ? true : false)   : false)} 
                                                onChange={onchanged}
                                                style={{
                                                    color: "var(--primary-1)",
                                                }}
                                                id={v.enID+vi} 
                                            />
                                            <label htmlFor={v.enID+vi}>{vi}</label>
                                        </div>
                                    )
                                })}
                            </div>
                            {
                                (v.desc) ? (
                                    <div className="desc-q">
                                        {v.desc}
                                    </div>
                                ) : ""
                            }
                        </div>
                        <div className="q-divider"></div>
                        </>
                    )
                case "multi":
                    let num9 = globalState[v.enID];
                    if(!num9) {
                        num9 = []
                    }
                    if(!num9.length){
                        num9 = []
                    } else {
                        num9 = globalState[v.enID].map((v) => parseInt(v))
                    }
                    return (
                        <>
                        <div className="q-simple" key={i}>
                            <div className="text-q">
                                <FontAwesomeIcon className={"circle " + ((showError ? ((!num9) ? "error": ((num9.length === 0) ? "error": "active")): ((num9)? ((num9.length === 0) ? "": "active") : "")))} icon={faCircle}/>{v.title}
                            </div>
                            <div className="data-q">
                                {v.answers.map((vi, ii) => {
                                    return (
                                        <div key={ii}>
                                            <Checkbox 
                                                type="checkbox" 
                                                id={v.enID+vi} 
                                                name={v.enID} 
                                                value={ii+1} 
                                                checked={((num9) ?  ((num9.findIndex(value => parseInt(value) === ii+1) !== -1) ? true : false)   : false)} 
                                                onChange={onchanged}
                                                style={{
                                                    color: "var(--primary-1)",
                                                }}
                                            />
                                            {/* <input type="checkbox" id={vi} name={v.enID} value={ii+1} checked={((globalState[v.enID]) ?  ((globalState[v.enID].findIndex(value => parseInt(value) === ii+1) !== -1) ? true : false)   : false)} onChange={onchanged}/> */}
                                            <label htmlFor={v.enID+vi}>{vi}</label>
                                        </div>
                                    )
                                })}
                            </div>
                            {
                                (v.desc) ? (
                                    <div className="desc-q">
                                        {v.desc}
                                    </div>
                                ) : ""
                            }
                        </div>
                        <div className="q-divider"></div>
                        </>
                    )
                case "simpleimage":
                    return (
                        <>
                        <div className="q-simple" key={i}>
                            <div className="text-q">
                                <FontAwesomeIcon 
                                    className={"circle " + ((showError ? ((!globalState[v.enID]) ? "error": "active") : ((globalState[v.enID])? "active" : "")))} 
                                    icon={faCircle}
                                />{v.title}
                            </div>
                            <div className="data-q-image">
                                {v.answers.map((vi, ii) => {
                                    return (
                                        <div 
                                            className={"item-image " + (((globalState[v.enID]) ?  ((parseInt(globalState[v.enID]) === ii+1) ? "active" : "")   : ""))} 
                                            style={{textAlign: "right"}} 
                                            key={ii}
                                            onClick={(e) => {
                                                let event = {
                                                    target: {
                                                        name: v.enID,
                                                        value: ii+1
                                                    }
                                                }
                                                onchanged(event)
                                            }}
                                        >
                                            <img src={vi.image}/>
                                            {/* <input type="checkbox" id={vi.desc} name={v.enID} value={ii+1} checked={((globalState[v.enID]) ?  ((globalState[v.enID].findIndex(value => parseInt(value) === ii+1) !== -1) ? true : false)   : false)} onChange={onchanged}/> */}
                                            <label className="item-image-text" htmlFor={vi.desc}>{vi.text}</label>
                                            <label className="item-image-desc" htmlFor={vi.desc}>{vi.desc}</label>
                                        </div>
                                    )
                                })}
                            </div>
                            {
                                (v.desc) ? (
                                    <div className="desc-q">
                                        {v.desc}
                                    </div>
                                ) : ""
                            }
                        </div>
                        <div className="q-divider"></div>
                        </>
                    )
                case "simplerange":
                    return (
                        <>
                        <div className="q-simple" key={i}>
                            <div className="text-q">
                                <FontAwesomeIcon className={"circle " + ((showError ? ((!globalState[v.enID]) ? "error": "active") : ((globalState[v.enID])? "active" : "")))} icon={faCircle}/>{v.title}
                            </div>
                            <div className="data-q-image">
                                {v.answers.map((vi, ii) => {
                                    return (
                                        <div 
                                            className={"item-range " + (((globalState[v.enID]) ?  ((parseInt(globalState[v.enID]) === ii+1) ? "active" : "")   : ""))} 
                                            style={{textAlign: "center"}} 
                                            key={ii}
                                            onClick={(e) => {
                                                let event = {
                                                    target: {
                                                        name: v.enID,
                                                        value: ii+1
                                                    }
                                                }
                                                onchanged(event)
                                            }}
                                        >
                                            {/* <img src={vi.image}/> */}
                                            {/* <input type="checkbox" id={vi.desc} name={v.enID} value={ii+1} checked={((globalState[v.enID]) ?  ((globalState[v.enID].findIndex(value => parseInt(value) === ii+1) !== -1) ? true : false)   : false)} onChange={onchanged}/> */}
                                            <label className="item-image-text" htmlFor={vi}>{vi}</label>
                                            {/* <label className="item-image-desc" htmlFor={vi.desc}>{vi.desc}</label> */}
                                        </div>
                                    )
                                })}
                            </div>
                            {
                                (v.desc) ? (
                                    <div className="desc-q">
                                        {v.desc}
                                    </div>
                                ) : ""
                            }
                        </div>
                        <div className="q-divider"></div>
                        </>
                    )
                default:
                    return ""
            }
        })
    }
    const sendLogin = async () => {
        let check = checkIsMobile(makeNumEn(mobile));
        if(!check) {
            setErrMobile("شماره درست نیست");
            return;
        } else {
            setErrMobile("")
        }
        let formData = new FormData();
        formData.set('U_MOBILE', check);
        setLoadingLogin(true);
        let response = await PostDataPromise(process.env.REACT_APP_API + '/api/v1/disposable',formData);
        setLoadingLogin(false);
        response = JSON.parse(response); 
        if (response.status === 'success') {
            setStep("step7");
            setTime(120);
            setPuased(false);
            setPass("");
        } else if (response.status === 'error') {
            setErrMobile(response.data.message);
        } else if (response.status === 'error-no-internet') {
            setErrMobile(response.data.message);
        }
    }
    const populateGoods = async (goods, colorMax = []) => {
        setLoadingProds(true);
        let newGoods = [];
        let promisses = [];
        for (let i = 0; i < goods.length; i++) {
            const good = goods[i];
            let formData = new FormData();
            formData.append('G_CODE',good.gCode);
            let response = PostDataPromise(process.env.REACT_APP_API + '/api/v1/exb/goods/select',formData);
            promisses.push(response)
        }
        await Promise.all(promisses);
        for (let i = 0; i < promisses.length; i++) {
            const res = await promisses[i];
            let newRes = JSON.parse(res);
            if (newRes.status === 'success') {
                let minPrice = newRes.goods_shop[0].SH_G_PRICE;
                let mainShopGood = newRes.goods_shop[0];
                let shoplogo = newRes.goods_shop[0].SH_LOGO;
                let shopname = newRes.goods_shop[0].SH_NAME;
                for (let j = 0; j < newRes.goods_shop.length; j++) {
                    const shopgood = newRes.goods_shop[j];
                    if(shopgood.SH_G_PRICE < minPrice){
                        minPrice = shopgood.SH_G_PRICE;
                        mainShopGood = shopgood
                    }
                }
                if(newRes.data.G_CODE === 474){
                    let shopgoodsSelectAll = [];
                    for (let k = 0; k < colorMax.length; k++) {
                        const colorMax1 = colorMax[k];
                        let shopgoodsSelect = newRes.goods_shop.filter((vsh) => Math.floor(parseFloat(vsh.G_COL_NAME)) === colorMax1);
                        shopgoodsSelectAll = [
                            ...shopgoodsSelectAll,
                            ...shopgoodsSelect
                        ]
                    }
                    setColorsSelector(shopgoodsSelectAll)
                }
                let newGood = {
                    gCode: newRes.data.G_CODE,
                    link: `https://luxinlux.com/good/${newRes.data.G_CODE}/${newRes.data.G_URL}/`,
                    name: newRes.data.G_NAME,
                    image: newRes.data.G_IMAGE,
                    price: minPrice,
                    shop: shopname,
                    shopImage: shoplogo,
                    mainShopGood: mainShopGood
                }
                newGoods.push(newGood);
            }
        }
        setLoadingProds(false);
        return newGoods
    }
    const makeLogic = async (state = globalState) => {
        // console.log("dddddd",state);
        setLoadingProds(true);
        let goodsMain = [
            {
                gCode: 546,
                link: "https://luxinlux.com/good/546/روغن-آرگان-ارایبا-Erayba-K15",
                name: "روغن آرگان ارایبا Erayba K15",
                image: "https://api.luxinlux.com/images/goods_images/546.webp",
                price: "752000",
                shop: "عالم آرا",
                shopImage: "https://api.luxinlux.com/images/shop_images/2.jpg",
            },
            {
                gCode: 475,
                link: "https://luxinlux.com/good/475/%DA%A9%D8%B1%D9%85-%D8%B1%D9%86%DA%AF-%D8%B1%D9%88%D8%B4%D9%86-%DA%A9%D9%86%D9%86%D8%AF%D9%87-%D9%85%D9%88-%D8%A7%D8%B1%D8%A7%DB%8C%D8%A8%D8%A7-Erayba-Gamma-Blond",
                name: "کرم رنگ روشن کننده مو ارایبا Erayba Gamma Blond",
                image: "https://api.luxinlux.com/images/goods_images/475.webp",
                price: "350000",
                shop: "عالم آرا",
                shopImage: "https://api.luxinlux.com/images/shop_images/2.jpg",
            },
            {
                gCode: 539,
                link: "https://luxinlux.com/good/539/%D8%B4%D8%A7%D9%85%D9%BE%D9%88-%D8%B6%D8%AF%E2%80%8C-%D8%B2%D8%B1%D8%AF%DB%8C-%D8%AF%DB%8C%D9%84%DB%8C-%D8%A7%DA%A9%D8%AA%DB%8C%D9%88-%D8%A7%D8%B1%D8%A7%DB%8C%D8%A8%D8%A7-Erayba-D52",
                name: "شامپو ضد‌ زردی دیلی اکتیو ارایبا Erayba D52",
                image: "https://api.luxinlux.com/images/goods_images/539.webp",
                price: "490000",
                shop: "عالم آرا",
                shopImage: "https://api.luxinlux.com/images/shop_images/2.jpg",
            },
            {
                gCode: 429,
                link: "https://luxinlux.com/good/429/%D8%A7%D8%B3%D9%BE%D8%B1%DB%8C-%D9%86%D8%B1%D9%85-%DA%A9%D9%86%D9%86%D8%AF%D9%87-%DA%A9%D9%84%D8%A7%D8%B3%D8%AA%DB%8C%D9%86-%D9%85%D9%88-%D8%AF%D9%88-%D9%81%D8%A7%D8%B2-%D9%86%D9%88%D8%AA%D8%B1%D9%88%D8%A7%DA%A9%D8%AA%DB%8C%D9%88-%D8%A7%D8%B1%D8%A7%DB%8C%D8%A8%D8%A7-Erayba-N18",
                name: "اسپری نرم کننده کلاستین مو دو فاز نوترواکتیو ارایبا Erayba N18",
                image: "https://api.luxinlux.com/images/goods_images/539.webp",
                price: "785000",
                shop: "عالم آرا",
                shopImage: "https://api.luxinlux.com/images/shop_images/2.jpg",
            },
            {
                gCode: 498,
                link: "https://luxinlux.com/good/498/%D8%B3%D8%AA-%D9%81%D8%B1%E2%80%8C%DA%A9%D9%86%D9%86%D8%AF%D9%87-%D9%85%D9%88%D9%87%D8%A7%DB%8C-%D8%AD%D8%B3%D8%A7%D8%B3-%D8%A7%D8%B1%D8%A7%DB%8C%D8%A8%D8%A7-Erayba---M80",
                name: "ست فر‌کننده موهای حساس ارایبا Erayba M80",
                image: "https://api.luxinlux.com/images/goods_images/498.webp",
                price: "854000",
                shop: "عالم آرا",
                shopImage: "https://api.luxinlux.com/images/shop_images/2.jpg",
            },
            {
                gCode: 497,
                link: "https://luxinlux.com/good/497/%D8%B3%D8%AA-%D8%B5%D8%A7%D9%81-%DA%A9%D9%86%D9%86%D8%AF%D9%87-%DA%A9%D8%B1%D8%A7%D8%AA%DB%8C%D9%86-%D8%A7%D8%B1%D8%A7%DB%8C%D8%A8%D8%A7-Erayba--M70",
                name: "ست صاف کننده کراتین ارایبا Erayba M70",
                image: "https://api.luxinlux.com/images/goods_images/497.webp",
                price: "2764000",
                shop: "عالم آرا",
                shopImage: "https://api.luxinlux.com/images/shop_images/2.jpg",
            },
            {
                gCode: 495,
                link: "https://luxinlux.com/good/495/%D8%B3%D8%AA-%D9%85%D8%A7%D8%B3%DA%A9-%D8%AD%D8%AC%D9%85-%D8%AF%D9%87%D9%86%D8%AF%D9%87-%DA%A9%D8%B1%D8%A7%D8%AA%DB%8C%D9%86-%D8%A7%D8%B1%D8%A7%DB%8C%D8%A8%D8%A7-Erayba-M50",
                name: "ست ماسک حجم دهنده کراتین ارایبا Erayba M50",
                image: "https://api.luxinlux.com/images/goods_images/495.webp",
                price: "2626000",
                shop: "عالم آرا",
                shopImage: "https://api.luxinlux.com/images/shop_images/2.jpg",
            },
            {
                gCode: 541,
                link: "https://luxinlux.com/good/541/%D8%B4%D8%A7%D9%85%D9%BE%D9%88-%D9%85%D9%88%D9%87%D8%A7%DB%8C-%D8%B1%D9%86%DA%AF-%D8%B4%D8%AF%D9%87-%D8%A7%D8%B1%D8%A7%DB%8C%D8%A8%D8%A7-Erayba-D62",
                name: "شامپو موهای رنگ شده ارایبا Erayba D62",
                image: "https://api.luxinlux.com/images/goods_images/541.webp",
                price: "490000",
                shop: "عالم آرا",
                shopImage: "https://api.luxinlux.com/images/shop_images/2.jpg",
            },
            {
                gCode: 1372,
                link: "https://luxinlux.com/good/1372/%DA%A9%D8%B1%D9%85-%D8%A7%DA%A9%D8%B3%DB%8C%D8%AF%D8%A7%D9%86-%D9%85%D9%88-(6-%D8%AF%D8%B1%D8%B5%D8%AF)-%D8%A7%D8%B1%D8%A7%DB%8C%D8%A8%D8%A7-Erayba-Gamma-G20v",
                name: "کرم اکسیدان مو (6 درصد) ارایبا Erayba Gamma G20v",
                image: "https://api.luxinlux.com/images/goods_images/1372.webp",
                price: "183000",
                shop: "عالم آرا",
                shopImage: "https://api.luxinlux.com/images/shop_images/2.jpg",
            },
            {
                gCode: 1371,
                link: "https://luxinlux.com/good/1371/%DA%A9%D8%B1%D9%85-%D8%A7%DA%A9%D8%B3%DB%8C%D8%AF%D8%A7%D9%86-%D9%85%D9%88-(9-%D8%AF%D8%B1%D8%B5%D8%AF)-%D8%A7%D8%B1%D8%A7%DB%8C%D8%A8%D8%A7-Erayba-Gamma-G30v",
                name: "کرم اکسیدان مو (9 درصد) ارایبا Erayba Gamma G30v",
                image: "https://api.luxinlux.com/images/goods_images/1371.webp",
                price: "183000",
                shop: "عالم آرا",
                shopImage: "https://api.luxinlux.com/images/shop_images/2.jpg",
            },
        ]
        let validate = validatePage("all", state);
        if(!validate){
            return []
        }
        // let answers = ["رنگ مو"];
        let answers = [
            {
                gCode: 474,
                link: "https://luxinlux.com/good/474/%DA%A9%D8%B1%D9%85-%D8%B1%D9%86%DA%AF-%D9%85%D9%88--%D9%81%D8%A7%D9%82%D8%AF-%D8%A2%D9%85%D9%88%D9%86%DB%8C%D8%A7%DA%A9-%D8%A7%D8%B1%D8%A7%DB%8C%D8%A8%D8%A7-Erayba--Gamma-Color",
                name: "کرم رنگ مو فاقد آمونیاک ارایبا Erayba Gamma Color",
                image: "https://api.luxinlux.com/images/goods_images/474.webp",
                price: "350000",
                shop: "عالم آرا",
                shopImage: "https://api.luxinlux.com/images/shop_images/2.jpg",
            }
        ];
        let colors = [];
        // console.log(globalState)
        let numtemp1 = state["color6"];
        let numtemp2 = (state["color7"]) ? state["color7"] : 1;
        let numtemp3 = (state["color8"]) ? state["color8"] : 1;
        let num1 = (6 - parseInt(numtemp1)) + ( 5 - parseInt(numtemp2)) + (parseInt(numtemp3))
        // console.log("sssss", num1, numtemp1, numtemp2, numtemp3)
        if(num1 === 12){
            colors.push({1: 1, 2: 3, 3: 5, l: 1});
        }
        if(num1 > 8 && num1 < 12){
            colors.push({1: 1, 2: 4, 3: 6, l: 1});
        }
        if(num1 < 9){
            colors.push({1: 1, 2: 6, 3: 12, l: 1});
        }
        let num2 = parseInt(state["color5"])
        let num3 = parseInt(state["color16"]);
        if(num3 === 1){
            // answers.push(goodsMain[1])
            // answers.push("کرم روشن کننده مو");
            let first = num2;
            let thrd = ((num2 + 2 < 12) ? num2 + 2 : 12);
            let secnd = Math.floor((first + thrd)/2);

            colors.push({1: first, 2: secnd, 3: thrd, l: 2});
        }   
        if(num3 === 2){
            colors.push({1: num2, 2: num2, 3: num2, l: 2});
        }
        if(num3 === 3){
            let first = ((num2 - 2 > 0) ? num2 - 2 : 1);
            let thrd = num2;
            let secnd = Math.floor((first + thrd)/2);

            colors.push({1: first, 2: secnd , 3: thrd, l: 2});
        }
        let num4 = parseInt(state["color13"])
        let num5 = parseInt(state["color14"])
        if(num4 === 2){
            if(num5 > 7 && num5 < 11){
                colors.push({1: 10, 2: 11, 3: 12, l: 3});
            }
            if(num5 < 8){
                colors.push({1: 7, 2: 8, 3: 9, l: 3});
            }
        }
        let num6 = parseInt(state["color9"])
        if(num6 === 2){
            let tempColor = ((num2 - 1 > 0) ? num2 - 1 : 1)
            colors.push({1: tempColor, 2: tempColor, 3: tempColor, l: 4});
        }
        let num7 = (6 - parseInt(state["color3"])) + ( 6 - parseInt(state["color4"]))
        if(num7 > 1 && num7 < 6){
            colors.push({1: 1, 2: 4, 3: 6, l: 5});
        }
        if(num7 > 5){
            colors.push({1: 1, 2: 6, 3: 12, l: 5});
        }
        let num8 = parseInt(state["color14"])
        if(num8 === 2){
            answers.push(goodsMain[2])
            // answers.push("شامپوی ضد زردی");
            answers.push(goodsMain[3])
            // answers.push("اسپری نرم کننده کلاستین مو دو فاز نوترواکتیو  Erayba N18");
        }
        let num9 = state["color17"];
        if(!num9.length){
            num9 = []
        } else {
            num9 = state["color17"].map((v) => parseInt(v))
        }
        if(num9.findIndex(v => v === 8) !== -1){
            answers.push(goodsMain[4])
            // answers.push("ست فر کننده مو");
        }
        if(num9.findIndex(v => v === 9) !== -1){
            answers.push(goodsMain[5])
            // answers.push("ست صاف کننده");
        }
        if(num9.findIndex(v => v === 7) !== -1){
            answers.push(goodsMain[6])
            // answers.push("ست ماسک حجم دهنده کراتین ارایبا Erayba M50")
        }
        let num10 = parseInt(state["color1"])
        if(num10 === 3 || num10 === 4){
            answers.push(goodsMain[3])
            // answers.push("اسپری نرم کننده کلاستین مو دو فاز نوترواکتیو  Erayba N18");
        }
        let num11 = parseInt(state["color9"])
        if(num11 === 2){
            answers.push(goodsMain[0])
            // answers.push("روغن آرگان");
            answers.push(goodsMain[7])
            // answers.push("شامپوی مخصوص موهای رنگ شده");
        }
        let keys = {};
        for (let i = 0; i < 12; i++) {
            keys[i+1] = 0;     
        }
        for (let i = 0; i < colors.length; i++) {
            const color = colors[i];
            let first = color[1];
            let last = color[3];
            // console.log(first, last, colors.length - i, Math.pow(2, colors.length - i) );
            for (let j = first; j <= last; j++) {
                if(j !== 2){
                    keys[j] = keys[j] + Math.pow(2, colors.length - i)           
                }
            }
        }
        let max = 0;
        let color = 0;
        for (let i = 0; i < 12; i++) {
            if(keys[i+1] > max){
                max = keys[i+1];
                color = i+1
            }
        }
        let maxes = [];
        for (let i = 0; i < 12; i++) {
            if(keys[i+1] === max){
                maxes.push(i+1)
            }
        }
        // console.log(maxes, keys, colors);
        let average = 0;
        let sum = 0;
        for (let i = 0; i < maxes.length; i++) {
            const element = maxes[i];
            sum = sum + element;
        }
        average = Math.floor(sum/maxes.length);

        let newMaxes = [];
        let num12 = parseInt(state["color16"]);
        let num13 = parseInt(state["color5"])
        if(num12 === 1){
            if(num13 < maxes[maxes.length - 1]){
                newMaxes.push(maxes[maxes.length - 1]);
            } else {
                newMaxes.push((num13 + 1 < 13 && num13 + 1 !== 2) ? num13 + 1 : 12);
            }
        }
        if(num12 === 2){
            newMaxes.push(average);
        }
        if(num12 === 3){
            if(num13 > maxes[0]){
                newMaxes.push(maxes[0]);
            } else {
                newMaxes.push((num13 - 1 > 0 && num13 - 1 !== 2) ? num13 - 1 : 1);
            }
            
        }
        if(num12 === 4){
            newMaxes.push(average);
        }

        // 8,9
        if(newMaxes[0] < 7){
            answers.push(goodsMain[8])
        }
        if(newMaxes[0] > 6){
            answers.push(goodsMain[9])
        }
        let highlight = state["color18"];
        if(highlight){
            setColorsSelected(highlight)
        }
        let newGoods = await populateGoods(answers, newMaxes);
        // console.log(answers)
        return {
            goods: newGoods,
            colors: keys,
            color: "شماره رنگ " + color,
            maxes: newMaxes
        }
    }
    const makeColorResult = (cols) => {
        return cols.map((v, i) => {
            let color = hairColorsFa[v - 1];
            return (
                <div 
                    className={"item-image "} 
                    style={{textAlign: "right"}} 
                    key={i}
                >
                    <img src={color.image}/>
                    <div className="item-image-data">
                        <label className="item-image-text" htmlFor={color.desc}>{color.text}</label>
                        <label className="item-image-desc" htmlFor={color.desc}>{color.desc}</label>
                    </div>
                </div>
            )
        })
    }
    const makeLastItems = () => {
        let val = [];
        let ans;
        switch(step){
            case "step5":
                ans = logicAns;
                // console.log(ans);
                if(loadingProds || !ans.maxes){
                    val.push(
                        <div className="box answers">
                            <Loading/>
                        </div>
                    )
                } else {
                    val.push(
                        <div className="box answers" ref={mainselector}>
                            <div className="q-simple">
                                <div className="text-q">
                                    <FontAwesomeIcon className={"circle " + ((showError ? (!colorsSelected ? "error": "active") : ((colorsSelected)? "active" : "")))} icon={faCircle}/>شما ترجیح میدید هایلایت رنگ موهاتون چه رنگی باشه؟
                                </div>
                                <div className="desc-q">
                                    رنگ موهایی که بهتون پیشنهاد میدیم هایلایت هم دارن. رنگ هایلایتی که انتخاب می‌کنید در نور روی موهاتون نمایان میشه.
                                </div>
                            </div>
                            <ColorSelector 
                                shopgoods={colorsSelector} 
                                colors={ans.maxes} 
                                selectedCode={colorsSelected} 
                                selected={(e) => {
                                    // color17
                                    let temp = {...globalState};
                                    temp["color18"] = e;
                                    setGlobalState(temp);
                                    setColorsSelected(e);
                                }}
                            />
                        </div>
                    );
                }
                break;
            case "step6":
                val.push(
                    <div className="ans">
                        <div className="background"><img src={bgBlur} alt="background"/></div>
                        <div className="login">
                            <div className="top">
                                ورود/ثبت نام
                            </div>
                            <div className="content">
                                <InputTitle>
                                    برای مشاهده محصولات لطفا ابتدا به سایت ورود کنید.
                                </InputTitle>
                                <TextInputWTitle
                                    name={"Mobile"}
                                    value={mobile}
                                    error={errMobile}
                                    title="موبایل"
                                    onchange={(e) => {
                                        let check = checkIsMobile(makeNumEn(e.target.value))
                                        if(!check) {
                                            setErrMobile("شماره درست نیست")
                                        } else {
                                            setErrMobile("")
                                        }
                                        setMobile(makeNumEn(e.target.value))
                                    }}
                                />
                            </div>
                            <div className="actions">
                                <Button 
                                    color="primary" 
                                    className="btn-1"
                                    variant="outlined" 
                                    disabled={false} 
                                    onClick={() => {
                                        setErrMobile("")
                                        setMobile("")
                                        setStep("step5")
                                    }}
                                >
                                    مرحله قبل
                                </Button>
                                <Button 
                                    color="primary" 
                                    className="btn-2"
                                    variant="contained"
                                    disabled={loadingLogin} 
                                    onClick={sendLogin}
                                >
                                    {
                                        (loadingLogin) ? (
                                            <Loading small={true}/>
                                        ) : (
                                            "ارسال کد تایید"
                                        )
                                    }
                                </Button>
                            </div>
                        </div>
                    </div>
                );
                break;
            case "step7":
                val.push(
                    <div className="ans">
                        <div className="background"><img src={bgBlur} alt="background"/></div>
                        <div className="login">
                            <div className="top">
                                کد تایید
                            </div>
                            <div className="content">
                                <InputTitle>
                                    کد به شماره ی {mobile} ارسال شد
                                </InputTitle>
                                <TextInputWTitle
                                    name={"Pass"}
                                    value={pass}
                                    error={errMobile}
                                    title="کد تایید"
                                    onchange={(e) => {
                                        setPass(makeNumEn(e.target.value))
                                    }}
                                />
                                <div style={{marginTop: "1rem"}}>
                                    {timer}
                                </div>
                            </div>
                            <div className="actions">
                                <Button 
                                    color="primary" 
                                    className="btn-1"
                                    variant="outlined" 
                                    disabled={false} 
                                    onClick={() => {
                                        setErrMobile("")
                                        setStep("step6")
                                    }}
                                >
                                    ویرایش شماره موبایل
                                </Button>
                                <Button 
                                    color="primary" 
                                    className="btn-2"
                                    variant="contained"
                                    disabled={loadingLogin} 
                                    onClick={async () => {
                                        let check = checkIsMobile(makeNumEn(mobile));
                                        let formData = new FormData();
                                        formData.append('U_TYPE', "MOBILE");
                                        formData.append('U_DATA', check);
                                        formData.append('U_DISPOSABLE', pass);
                                        setLoadingLogin(true);
                                        let response = await PostDataPromise(process.env.REACT_APP_API + '/api/v1/login',formData);
                                        setLoadingLogin(false);
                                        response = JSON.parse(response);
                                        if (response.status === 'success') {
                                            localStorage.setItem('token', response.data.token);
                                            localStorage.setItem('userdata', JSON.stringify(response.data));
                                            isLoginOut()
                                            setStep("step8");
                                            sendData();
                                            let ans = await makeLogic()
                                            setLogicAns(ans)
                                        } else if (response.status === 'error') {
                                            setErrMobile(response.data.message);
                                        } else if (response.status === 'error-no-internet') {
                                            setErrMobile(response.data.message);
                                        }
                                    }}
                                >
                                    {
                                        (loadingLogin) ? (
                                            <Loading small={true}/>
                                        ) : (
                                            "تایید کد"
                                        )
                                    }
                                </Button>
                            </div>
                        </div>
                    </div>
                );
                break;
            case "step8":
                ans = logicAns;
                // console.log(ans);
                if(loadingProds || !ans.maxes){
                    val.push(
                        <div className="box answers">
                            <Loading/>
                        </div>
                    )
                } else {
                    // console.log(ans.goods);
                    let baseGoods = [];
                    let addGoods = [];
                    ans.goods.forEach((vgood) => {
                        let basketselect = basketSelectedGoods.findIndex(gcode => vgood.gCode === gcode)
                        if(vgood.gCode === 474){
                            let shopgood = colorsSelector.find((vshop) => vshop.G_COL_CODE === colorsSelected)
                            let image = vgood.image;
                            if(shopgood){
                                if(shopgood.Image.length > 0){
                                    image = shopgood.Image[0]
                                }
                            }
                            
                            baseGoods.push({
                                ...vgood,
                                link: vgood.link + "?varient=" + colorsSelected,
                                image: image,
                                selected: (basketselect !== -1),
                            })
                            return;
                        }
                        if(vgood.gCode === 1371 || vgood.gCode === 1372){
                            baseGoods.push({
                                ...vgood,
                                selected: (basketselect !== -1),
                            });
                            return
                        }
                        addGoods.push({
                            ...vgood,
                            selected: (basketselect !== -1),
                            onChange: () => {
                                let temp = [...basketSelectedGoods];
                                if(basketselect !== -1){
                                    temp.splice(basketselect, 1);
                                } else {
                                    temp.push(vgood.gCode)
                                }
                                setBasketSelectedGoods(temp)
                            }
                        });
                        return;
                        
                    })
                    let oxidan1 = baseGoods.findIndex(g => g.gCode === 1371)
                    if(ans){
                        val.push(
                            <>
                            <div className="box answers">
                                {/* <div className="colors-ans">
                                    {makeColorResult(ans.maxes)}
                                </div> */}
                                {
                                    (ans.maxes.length > 1) ? (
                                        <div>
                                            پیشنهاد ما شماره رنگ‌های {ans.maxes.map((v,i) => `${v}${((i < ans.maxes.length - 2) ? ", " : ((i < ans.maxes.length - 1) ? " و " : ""))}`)} است. با توجه به ویژگی‌های ظاهری که داری این رنگ‌ها میتونن زیبایی و جذابیت موها و چهرتو بیشتر کنن.
                                        </div>
                                    ) : (
                                        <div>
                                            پیشنهاد ما شماره رنگ‌ {ans.maxes.map((v,i) => `${v}`)} است. با توجه به ویژگی‌های ظاهری که داری این رنگ‌ها میتونن زیبایی و جذابیت موها و چهرتو بیشتر کنن.
                                        </div>
                                    )
                                }
                                {
                                    (oxidan1 === -1)?(
                                        <div>
                                            برای رنگ کردن موهات، لازمه حتما رنگ مو رو با اکسیدان ترکیب کنی. پیشنهاد ما برای شما اکسیدان 6% هست.
                                        </div>
                                    ): (
                                        <div>
                                            برای رنگ کردن موهات، لازمه حتما رنگ مو رو با اکسیدان ترکیب کنی. پیشنهاد ما برای شما اکسیدان 9% هست.
                                        </div>
                                    )
                                }
                            </div>
                            <div className="box-2">
                                <GoodCartWithSelectorDouble 
                                    data1={baseGoods[0]} 
                                    data2={(baseGoods[1] ? baseGoods[1] : {})}
                                    selected={basketSelectedGoods.findIndex(gcode => gcode === 474) !== -1}
                                    onChange={() => {
                                        let basketselect = basketSelectedGoods.findIndex(gcode => gcode === 474)
                                        let temp = [...basketSelectedGoods];
                                        if(basketselect !== -1){
                                            temp.splice(basketselect, 1);
                                            basketselect = temp.findIndex(gcode => gcode === 1371 || gcode === 1372);
                                            if(basketselect !== -1){
                                                temp.splice(basketselect, 1);
                                            }
                                        } else {
                                            temp.push(474,1371,1372)
                                        }
                                        setBasketSelectedGoods(temp)
                                    }}
                                />
                            </div>
                            {
                                (addGoods.length) ? (
                                    <>
                                        <div className="box answers">
                                            محصولات پایین بهت کمک میکنن موهای سالم‌تری داشته باشی و رنگ موهاتو حفظ کنی.
                                        </div>
                                        <div className="box-2">
                                            <RibbonSuggetGoodSelector noPad={true} goods={addGoods}/>
                                        </div>
                                    </>
                                ) : ""
                            }
                            
                            </>
                        );
                    }
                }
                break;
        }
        return val;
    }
    const makeLastItemsBtns = () => {
        let val = [];
        switch(step){
            case "step5":
                val.push(
                    <div className="box">
                        <div className="actions end">
                            <Button 
                                color="primary" 
                                className="btn"
                                variant="outlined" 
                                disabled={false} 
                                onClick={() => {
                                    setDisBack(false)
                                    setDisNext(false)
                                    setStep("step4")
                                }}
                            >
                                مرحله قبل
                            </Button>
                            <Button 
                                color="primary" 
                                className="btn"
                                variant="contained"
                                disabled={false} 
                                onClick={async () => {
                                    let token = localStorage.getItem("token");
                                    if(token){
                                        goToTop();
                                        setDisBack(false);
                                        setDisNext(false);
                                        setShowError(false);
                                        setStep("step8");
                                        sendData();
                                        let ans = await makeLogic()
                                        setLogicAns(ans)
                                    } else {
                                        goToTop()
                                        setDisBack(false)
                                        setDisNext(false)
                                        setShowError(false);
                                        setStep("step6");
                                        let ans = await makeLogic()
                                        setLogicAns(ans)
                                    }
                                    
                                }}
                            >
                                مشاهده نتایج
                            </Button>
                        </div>
                    </div>
                );
                break;
            case "step6":
                val.push(
                    ""
                );
                break;
            case "step7":
                val.push(
                    ""
                );
                break;
            case "step8":
                val.push(
                    <div className="box">
                        {
                            (showError) ? (
                                <div className="actions error">
                                    <ReportProblemRounded style={{fontSize: "20px"}}/>برای اضافه کردن به سبد محصولی را انتخاب کنید.
                                </div>
                            ) : ""
                        }
                        <div className="actions end">
                            <Button 
                                color="primary" 
                                className="btn"
                                variant="outlined" 
                                disabled={false} 
                                onClick={() => {
                                    setDisBack(false)
                                    setDisNext(false)
                                    setStep("step5")
                                }}
                            >
                                مرحله قبل
                            </Button>
                            <Button 
                                color="primary" 
                                className="btn"
                                variant="contained"
                                disabled={false} 
                                onClick={() => {
                                    let ans = logicAns;
                                    if(colorsSelected){
                                        let goods = ans.goods;
                                        let tempSelected = basketSelectedGoods;
                                        let check = true;
                                        // console.log(tempSelected, goods);
                                        for (let i = 0; i < goods.length; i++) {
                                            const good = goods[i];
                                            let find = tempSelected.findIndex((v) => v === good.gCode);
                                            if(find !== -1){
                                                check = false;
                                                let shopGood = good.mainShopGood;
                                                if(good.gCode === 474){
                                                    shopGood = colorsSelector.find(v => v.G_COL_CODE === colorsSelected);
                                                }
                                                insertGood(shopGood)
                                            }
                                        }
                                        setShowError(check)
                                    }
                                }}
                            >
                                افزودن به سبد خرید
                            </Button>
                        </div>
                    </div>
                );
                break;
        }
        return val;
    }
    const validatePage = (stepC = step, state = globalState) => {
        let newQuestiosn = [...questions];
        let showedQuestions = newQuestiosn
        if(stepC !== "all"){
            showedQuestions = newQuestiosn.splice(stages[stepC].items[0], stages[stepC].items[1] - stages[stepC].items[0])
        }
        let valitation = false
        for (let i = 0; i < showedQuestions.length; i++) {
            const question = showedQuestions[i];
            let show = true
            if(question.showing){
                show = false;
                let find = questions.find((v2) => v2.enID === question.showing);
                let okays = question.paramShow.split("").map((v) => parseInt(v))
                if(okays.findIndex(value1 => parseInt(state[find.enID]) === value1) !== -1){
                    show = true;
                }
            }
            if(show){
                if(question.type === "multi"){
                    if(state[question.enID]) {
                        if(state[question.enID].length === 0){
                            setShowError(true)
                            valitation = true;
                        }
                    } else {
                        setShowError(true)
                        valitation = true;
                    }
                } else {
                    if(!state[question.enID]){
                        setShowError(true)
                        valitation = true;
                    }
                }
            }
        }
        return !valitation
    }
    const goToStep = (e) => {
        let validate = validatePage();
        if(validate){
            let keys = Object.keys(stages);
            let findI = keys.findIndex((v) => v === e);
            let newKey = keys[findI];
            goToTop()
            setDisBack((findI === 0))
            setDisNext((findI === keys.length - 1))
            setShowError(false);
            setStep(newKey)
        }
    }
    const validateNextStep = async () => {
        let keys = Object.keys(stages);
        let findI = keys.findIndex((v) => v === step);
        if(findI+1 === keys.length){
            let validate = validatePage("all");
            // let token = localStorage.getItem("token");
            if(validate){
                goToTop()
                setDisBack(false)
                setDisNext(false)
                setShowError(false);
                setStep("step5")
                let ans = await makeLogic()
                setLogicAns(ans)
                // goToTop()
                // setDisBack(false)
                // setDisNext(false)
                // setShowError(false);
                // setStep("step8");
                // sendData();
                // let ans = await makeLogic()
                // setLogicAns(ans)
            }
        } else {
            let validate = validatePage();
            if(validate){
                let newKey = keys[(findI+1 < keys.length) ? findI+1 : findI];
                goToTop()
                setDisBack(false)
                setDisNext((findI+1 === keys.length - 1))
                setShowError(false);
                setStep(newKey)
            }
        }
    }
    const back = () => {
        let keys = Object.keys(stages);
        let findI = keys.findIndex((v) => v === step);
        let newKey = 0;
        if(findI === -1) {
            newKey = keys[keys.length - 1];
        } else {
            newKey = keys[(findI-1 > -1) ? findI-1 : findI];
            setDisBack((findI-1 === 0))
            setDisNext(false)
        }
        goToTop()
        setShowError(false);
        setStep(newKey)
    }

    const goToTop = () => {
        setTimeout(() => {
            window.scrollTo({
                top: mainRef.current.offsetTop - 40,
                behavior: "smooth"
            })
        }, 50)
    }

    return (
        <Styles className="main-grid" ref={mainRef}>
            <div className="title-box">
                <div className="text-box">
                    پرسشنامه
                </div>
                <div className="desc-box">
                    به سوالات زیر پاسخ دهید و سپس محصولات پیشنهادی مارا مشاهده کنید
                </div>
            </div>
            {
                (step === "step1" || step === "step2" || step === "step3" || step === "step4") ? (
                    <>
                        <div className="box top">
                            <Steper steps={stages} step={step} setStep={goToStep} justify={true}/>
                        </div>
                        <div className="box">
                            {makeQuestions()}
                            {
                                (showError) ? (
                                    <div className="actions error">
                                        <ReportProblemRounded style={{fontSize: "20px"}}/>لطفا به تمامی سوالات پاسخ دهید.
                                    </div>
                                ) : ""
                            }
                            <div className="actions">
                                <Button 
                                    color="primary" 
                                    className="btn"
                                    variant="outlined" 
                                    disabled={disBack} 
                                    onClick={back}
                                >
                                    مرحله قبل
                                </Button>
                                <Button 
                                    color="primary" 
                                    className="btn"
                                    variant="contained"
                                    disabled={false} 
                                    onClick={validateNextStep}
                                >
                                    مرحله بعد
                                </Button>
                            </div>
                        </div>
                    </>
                ): ""
            }
            {
                (step === "step5" || step === "step6" || step === "step7" || step === "step8") ? (
                    <>
                    {makeLastItems()}
                    {makeLastItemsBtns()}
                    </>
                ): ""
            }
        </Styles>
    )
}
export default SurveyComp




const stages = {
    'step1': {
      icon: <FontAwesomeIcon icon={faCircle}/>,
      title: 'ویژگی‌های ظاهری شما',
      items: [0, 5],
    },
    'step2': {
      icon: <FontAwesomeIcon icon={faCircle}/>,
      title: 'سفیدی موهای شما',
      items: [5, 8],
    },
    'step3': {
        icon: <FontAwesomeIcon icon={faCircle}/>,
        title: 'آرایش موهای شما',
        items: [8, 15],
    },
    'step4': {
      icon: <FontAwesomeIcon icon={faCircle}/>,
      title: 'نتیجه دلخواه شما',
      items: [15, 17],
    },
}

const hairColors = [
    {
        image: ColorsCampaign.color1,
        text: "black",
        desc: "level 1"
    },
    {
        image: ColorsCampaign.color2,
        text: "black",
        desc: "level 2"
    },
    {
        image: ColorsCampaign.color3,
        text: "black",
        desc: "level 3"
    },
    {
        image: ColorsCampaign.color4,
        text: "brown",
        desc: "level 4"
    },
    {
        image: ColorsCampaign.color5,
        text: "brown",
        desc: "level 5"
    },
    {
        image: ColorsCampaign.color6,
        text: "brown",
        desc: "level 6"
    },
    {
        image: ColorsCampaign.color7,
        text: "brown",
        desc: "level 7"
    },
    {
        image: ColorsCampaign.color8,
        text: "blonde",
        desc: "level 8"
    },
    {
        image: ColorsCampaign.color9,
        text: "blonde",
        desc: "level 9"
    },
    {
        image: ColorsCampaign.color10,
        text: "blonde",
        desc: "level 10"
    },
    {
        image: ColorsCampaign.color11,
        text: "blonde",
        desc: "level 11"
    },
    {
        image: ColorsCampaign.color12,
        text: "blonde",
        desc: "level 12"
    },
]

const hairColorsFa = [
    {
        image: ColorsCampaign.color1,
        text: "مشکی",
        desc: "شماره 1"
    },
    {
        image: ColorsCampaign.color2,
        text: "مشکی",
        desc: "شماره 2"
    },
    {
        image: ColorsCampaign.color3,
        text: "مشکی",
        desc: "شماره 3"
    },
    {
        image: ColorsCampaign.color4,
        text: "قهوه‌ای",
        desc: "شماره 4"
    },
    {
        image: ColorsCampaign.color5,
        text: "قهوه‌ای",
        desc: "شماره 5"
    },
    {
        image: ColorsCampaign.color6,
        text: "قهوه‌ای",
        desc: "شماره 6"
    },
    {
        image: ColorsCampaign.color7,
        text: "قهوه‌ای",
        desc: "شماره 7"
    },
    {
        image: ColorsCampaign.color8,
        text: "بلوند",
        desc: "شماره 8"
    },
    {
        image: ColorsCampaign.color9,
        text: "بلوند",
        desc: "شماره 9"
    },
    {
        image: ColorsCampaign.color10,
        text: "بلوند",
        desc: "شماره 10"
    },
    {
        image: ColorsCampaign.color11,
        text: "بلوند",
        desc: "شماره 11"
    },
    {
        image: ColorsCampaign.color12,
        text: "بلوند",
        desc: "شماره 12"
    },
]

const questions = [
    {
        index: 1,
        qnum: 1,
        enID: "color1",
        title: "کدوم گزینه مدل موی طبیعی شماست؟",
        type: "simple",
        answers: [
            "صاف",
            "موج دار",
            "فرفری",
            "پیچ خورده",
        ]
    },
    {
        index: 2,
        qnum: 2,
        enID: "color2",
        title: "رنگ موی طبیعی شما در ریشه چیه؟",
        type: "simpleimage",
        answers: hairColorsFa
    },
    {
        index: 3,
        qnum: 3,
        enID: "color3",
        title: "چه رنگی به رنگ پوستتون نزدیک تره؟",
        type: "simple",
        answers: [
            "بور",
            "روشن",
            "گندمی",
            "تیره",
            "سیر (خیلی تیره)",
        ]
    },
    {
        index: 4,
        qnum: 4,
        enID: "color4",
        title: "چشماتون چه رنگیه؟",
        type: "simple",
        answers: [
            "طوسی",
            "آبی",
            "سبز",
            "عسلی",
            "قهوه‌ای",
        ]
    },
    {
        index: 5,
        qnum: 5,
        enID: "color5",
        title: "درحال حاضر موهاتون چه رنگیه؟",
        type: "simpleimage",
        desc: "رنگیو انتخاب کنید که بیشترین همخوانی رو با قد متوسط موهاتون داره. اگر موی کوتاهی دارید روی انتهای مو متمرکز بشین نه ریشه مو.",
        answers: hairColorsFa
    },
    {
        index: 7,
        qnum: 6,
        enID: "color6",
        title: "بیشتر چه قسمتی از موهاتون سفید شده؟",
        type: "simple",
        answers: [
            "بطور یکنواخت تو ریشه پخش شده",
            "تو یه بخش‌هایی",
            "قاب صورت/شقیقه هام",
            "مطمئن نیستم",
            "هیچ موی سفیدی ندارم",
        ]
    },
    {
        index: 8,
        qnum: 7,
        enID: "color7",
        title: "چقد موی سفید دارید؟",
        type: "simple",
        showing: "color6",
        paramShow: "1234",
        desc: "اگر نمیتونید بین دو گزینه تصمیم بگیرید گزینه با درصد بالاتر رو انتخاب کنید.",
        answers: [
            "0 - 25%",
            "25% - 50%",
            "50% - 75%",
            "75% - 100%",
        ]
    },
    {
        index: 9,
        qnum: 8,
        enID: "color8",
        title: "وقتی تو گذشته موهاتونو رنگ کردین توی رنگ کردن موهای سفید با مشکل مواجه شدید؟",
        type: "simple",
        showing: "color6",
        paramShow: "1234",
        answers: [
            "خیر",
            "مطمئن نیستم",
            "بله",
        ]
    },

    {
        index: 11,
        qnum: 9,
        enID: "color9",
        title: "آیا موهای شما در حال حاضر رنگ شدست؟",
        type: "simple",
        answers: [
            "خیر",
            "بله",
        ]
    },
    {
        index: 12,
        qnum: 10,
        enID: "color10",
        title: "معمولا موهاتونو کجا رنگ می‌کنید؟",
        type: "simple",
        showing: "color9",
        paramShow: "2",
        answers: [
            "سالن",
            "خونه",
            "هردو",
            "قبلا هیچوقت رنگ نشده",
        ]
    },
    {
        index: 13,
        qnum: 11,
        enID: "color11",
        title: "همه چی به زمان ربط داره... هرچند وقت یکبار موهاتونو رنگ میکنید؟",
        type: "simple",
        showing: "color9",
        paramShow: "2",
        answers: [
            "هر۲ هفته",
            "هر۳ هفته",
            "هر۴ هفته",
            "هر۵ هفته",
            "هر۶ هفته",
            "هر۷ هفته",
            "هر ۸ هفته یا بیشتر",
        ]
    },
    {
        index: 14,
        qnum: 12,
        enID: "color12",
        title: "چقد با رنگ کردن موهاتون تو خونه راحتید؟",
        type: "simple",
        answers: [
            "راحت نیست، تازه کارم",
            "تاحدودی راحت",
            "راحت، میدونم چیکار کنم",
            "خیلی راحت، من حرفه‌ایم",
        ]
    },
    {
        index: 15,
        qnum: 13,
        enID: "color13",
        title: "موهاتون رو دکلره زدین؟ داخل سالن یا خونه.",
        type: "simple",
        answers: [
            "خیر",
            "بله",
        ]
    },
    {
        index: 16,
        qnum: 13,
        enID: "color14",
        title: "دکلره شما به چه پایه‌ای رسیده است؟",
        showing: "color13",
        paramShow: "2",
        type: "simplerange",
        answers: [
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12
        ]
    },
    {
        index: 17,
        qnum: 14,
        enID: "color15",
        title: "آیا موهای شما پروتئین یا کراتین شده؟",
        type: "simple",
        answers: [
            "خیر",
            "بله",
        ]
    },
    
    {
        index: 19,
        qnum: 15,
        enID: "color16",
        title: "با توجه به رنگ موی فعلیتون کدوم نتیجه زیر مدنظر شماست؟",
        type: "simple",
        desc: "حواستون باشه که زدن رنگ موی روشن‌تر از رنگ موی فعلیتون ممکنه نتیجه یکدستی نداشته باشه و در نور دو رنگ بنظر برسه. اگر میخواید رنگ موی روشن‌تر بزنید حتما قبلش یا دکلره کنید یا از روشن کننده رنگ مو استفاده کنید.",
        answers: [
            "روشن تر از رنگ فعلی",
            "همون رنگ فعلی",
            "تیره تر از رنگ فعلی",
            "مطمئن نیستم",
        ]
    },
    {
        index: 20,
        qnum: 16,
        enID: "color17",
        title: "علاوه بر رنگ کردن آیا تغییر دیگه‌ای هم برای موهاتون در نظر دارید؟ (حداقل یکی حداکثر۲ تارو انتخاب کن)",
        type: "multi",
        max: 2,
        answers: [
            "ثبات رنگ",
            "درخشش بیشتر",
            "هیدراته کردن",
            "کاهش قرمزی",
            "جلوگیری از شکنندگی",
            "مهار موخوره",
            "افزایش حجم",
            "فر کردن مو",
            "صاف کردن",
            "محفاظت از مو",
        ]
    },
]


const StylesColorSelector =styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    .main-color {
        display: flex;
        justify-content: center;
        gap: 0.5rem;
        margin-bottom: 1rem;
        .item-image {
            position: sticky;
            top: 122px;
            display: flex;
            flex-direction: column;
            padding: 4px;
            border-radius: 4px;
            border: 1px solid var(--n-grey-2);
            gap: 8px;
            height: min-content;
            &.active {
                border: 1px solid var(--n-primary-2);
            }
            .item-image-data {
                display: flex;
                flex-direction: column;
                gap: 1rem;
            }
            img {
                width: 80px;
                height: 120px;
                object-fit: cover;
                display: block;
                border-radius: 4px;
            }
            .item-image-text {
                font-size: 1.3rem;
                color: var(--n-grey-9);
            }
            .item-image-desc {
                font-size: 1rem;
                color: var(--n-grey-7);
            }
        }
        .shop-colors {
            display: flex;
            flex-wrap: wrap;
            gap: 0.5rem;
        }
        .shop-good-item {
            cursor: pointer;
            display: flex;
            flex-direction: column;
            padding: 4px;
            border-radius: 4px;
            border: 1px solid #fff;
            gap: 8px;
            height: min-content;
            box-shadow: 0px 4px 30px -4px #0000001F;
            &.active {
                border: 1px solid var(--n-primary-2);
                box-shadow: 0px 0px 0px 4px #0E3D5C29;
            }
            .item-image-data {
                display: flex;
                flex-direction: column;
                gap: 1rem;
            }
            .image-container {
                .image-container-circle {
                    width: 110px;
                    height: 110px;
                    position: relative;
                    overflow: hidden;
                    border-radius: 20px;
                    img {
                        position: absolute;
                        top: -220px;
                        right: -20px;
                        width: 320px;
                        height: 320px;
                        object-fit: cover;
                        display: block;
                        border-radius: 4px;
                    }
                }
            }
            
            .item-image-text {
                font-size: 0.7rem;
                color: var(--n-grey-9);
            }
        }
    }
    @media screen and (max-width: 850px){
        .main-color {
            .shop-good-item {
                .image-container {
                    .image-container-circle {
                        width: 90px;
                        height: 90px;
                        img {
                            position: absolute;
                            top: -195px;
                            right: -15px;
                            width: 280px;
                            height: 280px;
                            object-fit: cover;
                            display: block;
                            border-radius: 4px;
                        }
                    }
                }
            }
        }
    }
`
const ColorSelector =({shopgoods = [], colors = [],selectedCode, selected = () => {}})=>{
    const makeColors = (colorMax1) => {
        let shopgoodsSelect = shopgoods.filter((vsh) => Math.floor(parseFloat(vsh.G_COL_NAME)) === colorMax1);
        return shopgoodsSelect.map((v, i) => {
            let image = "";
            if(v.Image.length > 0){
                image = v.Image[0]
            }
            return (
                <div className={"shop-good-item " + ((selectedCode === v.G_COL_CODE) ? "active" : "")} onClick={() => selected(v.G_COL_CODE)}>
                    <div className="image-container">
                        <div className="image-container-circle">
                            <img src={image}/>
                        </div>
                    </div>
                </div>
            )
        })
    }

    const makeMainColors = () => {
        return colors.map((v, i) => {
            const color = hairColorsFa[v - 1];
            return (
                <div key={i} className={"main-color"}>
                    {/* <div 
                        className={"item-image "} 
                        style={{textAlign: "right"}} 
                        key={i}
                    >
                        <img src={color.image}/>
                        <div className="item-image-data">
                            <label className="item-image-text" htmlFor={color.desc}>{color.text}</label>
                            <label className="item-image-desc" htmlFor={color.desc}>{color.desc}</label>
                        </div>
                    </div> */}
                    <div className="shop-colors">
                        {makeColors(v)}
                    </div>
                </div>
            )
        })
    }
    return (
        <StylesColorSelector>
            {makeMainColors()}
        </StylesColorSelector>
    )
}
